import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown, Button, Text } from '@gasbuddy/react-components';
import updateStationStatus from '../../../client/graphql/updateStationStatus';

const FUEL_OPTIONS = [
  { label: 'Has Gas', value: 1 },
  { label: 'Does Not Have Gas', value: 0 },
];

const POWER_OPTIONS = [
  { label: 'Has Power', value: 1 },
  { label: 'Does Not Have Power', value: 0 },
];

const DIESEL_OPTIONS = [
  { label: 'Has Diesel', value: 1 },
  { label: 'Does Not Have Diesel', value: 0 },
];

export default function AvailabilityForm({
  stationId,
  includeDiesel,
  isUpdatingStatus,
  onComplete,
}) {
  const [error, setError] = useState();
  const [isComponentReady, setIsComponentReady] = useState(false);
  const [availabilityStatus, setAvailabilityStatus] = useState({
    hasFuel: undefined,
    hasPower: undefined,
    hasDiesel: undefined,
  });
  const { hasFuel, hasPower, hasDiesel } = availabilityStatus;

  const onSubmit = useCallback((e) => {
    e.preventDefault();

    setError(undefined);

    async function submit() {
      try {
        await updateStationStatus(stationId, {
          hasFuel,
          hasPower,
          hasDiesel,
        });
        onComplete();
      } catch (err) {
        setError(err.message);
      }
    }

    submit();
  }, [stationId, hasFuel, hasPower, hasDiesel, onComplete]);

  const onSelectionChanged = useCallback(({ target }) => {
    if (target.value && isComponentReady) {
      setAvailabilityStatus({
        ...availabilityStatus,
        [target.name]: Number(target.value),
      });
    }
  }, [isComponentReady, availabilityStatus]);

  useEffect(() => {
    setIsComponentReady(true);
  }, []);

  return (
    <Form onSubmit={onSubmit}>
      <div>
        <label htmlFor="hasFuel">Gas Status</label>
        <Dropdown
          placeholder="Select Gas Status"
          id="hasFuel"
          name="hasFuel"
          options={FUEL_OPTIONS}
          onChange={onSelectionChanged}
          value={hasFuel}
        />
      </div>
      <div>
        <label htmlFor="hasPower">Power Status</label>
        <Dropdown
          placeholder="Select Power Status"
          id="hasPower"
          name="hasPower"
          options={POWER_OPTIONS}
          onChange={onSelectionChanged}
          value={hasPower}
        />
      </div>
      {includeDiesel && (
        <div>
          { /* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label htmlFor="hasDiesel">Diesel Status</label>
          <Dropdown
            placeholder="Select Diesel Status"
            id="hasDiesel"
            name="hasDiesel"
            options={DIESEL_OPTIONS}
            onChange={onSelectionChanged}
            value={hasDiesel}
          />
        </div>
      )}
      {error && (
        <Text as="p" color="orange">{error}</Text>
      )}
      <Button primary type="submit" wide loading={isUpdatingStatus}>
        Submit
      </Button>
    </Form>
  );
}

AvailabilityForm.propTypes = {
  stationId: PropTypes.number.isRequired,
  includeDiesel: PropTypes.bool,
  isUpdatingStatus: PropTypes.bool,
  onComplete: PropTypes.func.isRequired,
};

AvailabilityForm.defaultProps = {
  includeDiesel: false,
  isUpdatingStatus: false,
};
